import NewLandingPageConatiner from "./containers/NewLandingPageConatiner";
export default NewLandingPageConatiner;
